//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportEventCategoryIDsInputItem } from './IReportEventCategoryIDsInputItem';
import { IReportStudentIDsInputItem } from './IReportStudentIDsInputItem';
import { IReportTeacherIDsInputItem } from './IReportTeacherIDsInputItem';
import { LessonsTaughtReportGroupBy, ReportType } from './Enums';

export class HoursTaughtReportInputItem extends ReportInputItem implements IReportDateRangeInputItem, IReportEventCategoryIDsInputItem, IReportStudentIDsInputItem, IReportTeacherIDsInputItem {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    EventCategoryIDs: string[] = [];
    StudentIDs: string[] = [];
    TeacherIDs: string[] = [];
    GroupBy: LessonsTaughtReportGroupBy = LessonsTaughtReportGroupBy.Day;
    override readonly Type: ReportType = ReportType.HoursTaught;

    constructor(initializer?: Partial<Omit<HoursTaughtReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "HoursTaughtReportInputItem";
}
